import i18n from '@/plugins/i18n';

const detailsGraphs = () => ({
  gaugeCharts: [
    {
      width: '18%',
      widthInPer: '100%',
      title: i18n.global.t('vm.linux.swapMemory'),
      height: '12.5em',
      entityType: 'ServiceInstance',
      type: 'percentageView',
      chartBoxStyle: {
        height: '6.438rem',
        backgroundColor: 'rgb(21, 21, 21)',
      },
      configureRange: true,
      rangeProps: {
        leftFillColor: 'rgb(123,254,189)',
        rightFillColor: 'rgb(96,96,96)',
        labelText: '',
      },
      configureLabels: true,
      labelProps: {
        label0Text: '0 %',
        label50Value: 50,
        label50Text: '50 %',
        label100Value: 100,
        label100Text: '100 %',
      },
      axisMax: 100,
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'mobile_app_android_crash_percent',
      queryMetricType: 'readMetricsValue',
      chartType: 'RexGauge',
      aggregation: '/',
      aggregationNum: '100',
    },
  ],
  areaCharts: [
    // TODO: Change the metric values on the backend
    {
      width: '48%',
      widthInPer: '48%',
      title: i18n.global.t('system-and-user-cpu-usage'),

      header: {
        title: i18n.global.t('system-and-user-cpu-usage'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'windows_vm_cpu_usage_percentage,windows_vm_cpu_user_usage_percentage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      chartColor: ['#008FFB', '#00E396'],
      aggregation: '/',
      aggregationNum: '100',
      unit: '%',
      metricLabels: '',
      labelsIndex: '',
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('instance.percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('instance.percentage'),
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('disk-r-w-kb-s'),
      header: {
        title: i18n.global.t('disk-r-w-kb-s'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#1be7ff', '#6eeb83', '#e4fe1a'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_disk_read,windows_vm_disk_write',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s',
      metricLabels: '',
      labelsIndex: '',
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'KB',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('network-packet-status'),
      header: {
        title: i18n.global.t('network-packet-status'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#e63a46', '#d0efc5'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'windows_vm_network_status_incoming,windows_vm_network_status_outgoing',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s',
      metricLabels: '',
      labelsIndex: '',
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'KB/s',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('cpu-usage-app-process'),
      header: {
        title: i18n.global.t('cpu-usage-app-process'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'windows_vm_cpu_usage_app_pool',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      chartColor: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
      aggregation: '+',
      aggregationNum: '0',
      unit: i18n.global.t('instance.percentage'),
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
      compareTrend: true,
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('worker-set-app-process'),
      header: {
        title: i18n.global.t('worker-set-app-process'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'windows_vm_worker_process_set_pool',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'MB',
      metricLabels: '',
      labelsIndex: '',
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'MB',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('worker-process-app-process'),
      header: {
        title: i18n.global.t('worker-process-app-process'),
        titleIcon: '',
        content: [],
        toolbar: true,
        hideCPM: true,
      },
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'windows_vm_worker_process_app_pool',
      queryMetricType: 'readLabeledMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      metricLabels: '',
      labelsIndex: '',
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'MB',
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'MB',
      },
    },
  ],
  forcastDisabledLineAreaCharts: [
    {
      width: '48%',
      widthInPer: '48%',
      title: i18n.global.t('vm.windows.cpuPer'),

      header: {
        title: i18n.global.t('vm.windows.cpuPer'),
        subIconTitle: 'starFilled',
        titleIcon: '',
        content: [],
        toolbar: false,
        HideCenterMiscContent: true,
        hidePercentageParam: true,
      },
      chartColor: ['rgb(0,143,251)'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_cpu_usage_percentage',
      queryMetricType: 'readMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '100',
      unit: i18n.global.t('key'),
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
      compareTrend: true,
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('vm.windows.memRam'),
      header: {
        title: i18n.global.t('vm.windows.memRam'),
        subIconTitle: 'starFilled',
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#ffbe0b', '#ff046e', '#8338ec'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName:
        'windows_vm_memory_usage_total_bytes,windows_vm_memory_usage_available_bytes,windows_vm_memory_usage_used_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'MB',
      metricLabels: i18n.global.t('resources-js-ajax'),
      labelsIndex: '0, 1, 2 ',
      isSynchronized: false,
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'MB',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('storageAvailable'),

      header: {
        title: i18n.global.t('storageAvailable'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_storage_available_percentage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: i18n.global.t('key'),
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('percentage'),
      },
      compareTrend: true,
    },
    {
      width: '48%',
      widthInPer: '100%',
      isTraceGraph: true,
      title: i18n.global.t('vm.windows.networkBandwidth'),
      header: {
        title: i18n.global.t('vm.windows.networkBandwidth'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#564592', '#ecfa7f'],
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'windows_vm_network_bandwidth_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      aggregation: '/',
      aggregationNum: '1024',
      unit: 'KB/s',
      metricLabels: '',
      labelsIndex: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'KB/s',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'KB/s',
      },
    },
  ],
});
export default detailsGraphs;
